import React from "react";

import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { bustleBeeForCustomer } from "../Customer/bustleBees";
import { Customer } from "../Customer/schema";
import { CustomerTab } from "../CustomerTab/schema";
import { BillSplit } from "./schema";
import { hasCustomerPaidIn, getOrderItemCountIn } from "./selectors";

export const Pill = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex items-center justify-center gap-4 rounded-venue-brand bg-venue-tertiary px-12 py-4">
      {children}
    </div>
  );
};
export const CustomerPill = ({
  customer,
  count,
  paid,
}: {
  customer: Customer;
  count: number;
  paid: boolean;
}) => {
  const { t } = useTranslation("onsite");
  const bustleBee = bustleBeeForCustomer(customer);

  return (
    <div className="flex items-center justify-center gap-4 rounded-full bg-venue-tertiary px-12 py-4 whitespace-nowrap">
      {bustleBee && (
        <div className="h-32 w-32 p-4">
          <img src={bustleBee.img_96} alt={bustleBee.alt} />
        </div>
      )}
      <div>
        {customer.nickname}{" "}
        {paid ? (
          <span className="text-venue-highlight italic">
            {t("billSplit.paid")}
          </span>
        ) : (
          t("billSplit.customerPillCount", {
            orderItemCount: count,
          })
        )}
      </div>
    </div>
  );
};
export const CustomerPillList = ({
  billSplit,
  customerTab,
  currentCustomer,
  inline,
}: {
  billSplit: BillSplit;
  customerTab: CustomerTab;
  currentCustomer: Customer;
  inline?: boolean;
}) => {
  const { t } = useTranslation("onsite");
  const getHasCustomerPaid = hasCustomerPaidIn(billSplit);
  const getCustomersOrderItemCount = getOrderItemCountIn(
    billSplit,
    customerTab,
  );
  const otherCustomers = billSplit.customers.filter(
    (c) => c.uuid != currentCustomer.uuid,
  );
  return (
    <div
      className={classNames("flex gap-x-8 gap-y-8", {
        "overflow-x-auto": inline,
        "flex-wrap": !inline,
      })}
    >
      <CustomerPill
        customer={{ ...currentCustomer, nickname: t("customer.you") }}
        count={getCustomersOrderItemCount(currentCustomer)}
        paid={getHasCustomerPaid(currentCustomer)}
      />
      {otherCustomers.map((customer) => (
        <div className="flex-none">
          <CustomerPill
            customer={customer}
            count={getCustomersOrderItemCount(customer)}
            paid={getHasCustomerPaid(customer)}
          />
        </div>
      ))}
    </div>
  );
};
